import React, { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { translate } from '@td/shared_utils';
import PROVIDER_NOTIFICATION_SENT_STATUS from '../queries/provider-notification-sent-status.graphql';
import SEND_PROVIDER_JOIN_REQUEST from '../mutations/send-provider-join-request.graphql';
import toastr from '../../toastr';
import Button from '../components/Button';

const NOTIFICATION_TYPE = 'NOTIFICATION_PROVIDERJOINREQUEST';
const COMM_METHOD_SMS = 'SMS';
const availabilitySelector = prefs => (type, method) =>  prefs.some(
  ({ typeCd, commMethodPreferences }) => typeCd === type &&
    commMethodPreferences.some(({ enabled, commMethodCd }) => enabled && commMethodCd === method)
);

const ProviderJoinRequestAction = ({ consultation, notificationPreferences }) => {
  const [available, setAvailable] = useState(false);
  const [sent, setSent] = useState(true);
  const { consultationId, providerId } = consultation;

  const [loadSentStatus] = useLazyQuery(PROVIDER_NOTIFICATION_SENT_STATUS, {
    variables: {
      id:         parseInt(providerId),
      typeCode:   NOTIFICATION_TYPE,
      commMethod: COMM_METHOD_SMS,
      payload:    { consultationId }
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ provider: { notificationSent } }) => {
      setSent(notificationSent);
    }
  });

  useEffect(() => {
    setAvailable(
      availabilitySelector(notificationPreferences)(NOTIFICATION_TYPE, COMM_METHOD_SMS)
    );
  }, [notificationPreferences]);

  useEffect(() => {
    if (available && consultation) {
      loadSentStatus();
    }
  }, [available, consultation]);

  const [sendJoinRequest, { loading }] = useMutation(SEND_PROVIDER_JOIN_REQUEST, {
    variables:   { consultationId: parseInt(consultationId) },
    onCompleted: ({ sendProviderJoinRequest: { success } }) => {
      if (success) {
        setSent(true);
        toastr.success(
          translate(null, 'notification.provider_join_request.success', 'alert')
        );
      } else {
        toastr.error(
          translate(null, 'notification.provider_join_request.errors', 'request_failed')
        );
      }
    }
  });

  return (
    <React.Fragment>
      {
        available ? (
          <Button
            disabled={sent || loading}
            onClick={sendJoinRequest}
          >
            Notify the Provider
          </Button>
        ) : null
      }
    </React.Fragment>
  );
};

ProviderJoinRequestAction.propTypes = {
  consultation:            PropTypes.object,
  notificationPreferences: PropTypes.array
};

export default ProviderJoinRequestAction;
